import React from "react"
import esper from "../assets/svg/esperluette.svg"

export default ({text}) => (
    <div className="legende">
        <img src={esper} alt="" />{text}
      </div>
);